import React from 'react';
import { motion } from 'framer-motion';

const integrations = [
  { name: 'ServiceTitan', logo: '🔧' },
  { name: 'Housecall Pro', logo: '🏠' },
  { name: 'Jobber', logo: '📋' },
  { name: 'Workiz', logo: '⚡' },
  { name: 'FieldEdge', logo: '🔨' }
];

export const IntegrationSection = () => {
  return (
    <section id="integrations" className="py-24 bg-[#050505]">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl sm:text-4xl font-headline font-bold text-[#F4F4F5] mb-4">
            Works with the tools you already use.
          </h2>
          <p className="text-lg text-[#A1A1AA] font-body max-w-3xl mx-auto">
            We do not want you to change how you run your business. We just make your current tools work harder.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-6">
          {integrations.map((integration, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="glass p-8 rounded-xl flex flex-col items-center justify-center text-center hover:border-[#00E599]/30 transition-all"
            >
              <span className="text-4xl mb-3">{integration.logo}</span>
              <p className="text-sm font-body font-semibold text-[#F4F4F5]">{integration.name}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IntegrationSection;
